<template>
    <div class="app-wrapper">
        <div class="bundle-popup" v-if="confirmMessage">
            <div class="message">
                <p>{{ confirmMessage }}</p>
                <div class="buttons">
                    <button class="btn btn-outline" v-for="(b, i) in confirmButtons" :key="'button-'+i" @click="b.action">
                        {{ b.text }}
                    </button>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="padded">
                <div class="center-text">
                    <h2>{{ headlines.mainHeadline }}</h2>
                    <p>{{ headlines.mainDescription }}</p>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="padded">
                <section-title :text="headlines.section1Heading"></section-title>

                <section-sub-title :text="headlines.step1Heading"></section-sub-title>
                <div class="collection-wrapper">
                    <div class="elements">
                        <snowpeak-product-tile
                            :product="p"
                            :in-bundle="productInBundle(p)"
                            @add-product="addProductToBundle"
                            class="product-tile"
                            v-for="(p, index) in step1Products"
                            :key="'frame-'+index"
                            />
                    </div>
                </div>

                <section-sub-title :text="headlines.step2Heading"></section-sub-title>
                <div class="collection-wrapper">
                    <div class="elements">
                        <snowpeak-product-tile
                            :product="p"
                            :in-bundle="productInBundle(p)"
                            @add-product="addProductToBundle"
                            class="product-tile"
                            v-for="(p, index) in step2Products"
                            :key="'legs-'+index"
                            />
                    </div>
                </div>

                <section-title :text="headlines.section2Heading"></section-title>

                <section-sub-title :text="headlines.step3Heading"></section-sub-title>
                <div class="collection-wrapper">
                    <div class="elements">
                        <snowpeak-product-tile
                            :product="p"
                            :in-bundle="productInBundle(p)"
                            @add-product="addProductToBundle"
                            class="product-tile"
                            v-for="(p, index) in step3Products"
                            :key="'cooker-'+index"
                            />
                    </div>
                </div>

                <section-sub-title :text="headlines.step4Heading"></section-sub-title>
                <div class="collection-wrapper">
                    <div class="elements">
                        <snowpeak-product-tile
                            :product="p"
                            :in-bundle="productInBundle(p)"
                            @add-product="addProductToBundle"
                            class="product-tile"
                            v-for="(p, index) in step4Products"
                            :key="'surface-'+index"
                            />
                    </div>
                </div>

                <section-sub-title :text="headlines.step5Heading"></section-sub-title>
                <div class="collection-wrapper">
                    <div class="elements">
                        <snowpeak-product-tile
                            :product="p"
                            :in-bundle="productInBundle(p)"
                            @add-product="addProductToBundle"
                            class="product-tile"
                            v-for="(p, index) in step5Products"
                            :key="'storage-'+index"
                            />
                    </div>
                </div>

                <section-title :text="headlines.section3Heading"></section-title>

                <section-sub-title :text="headlines.step6Heading"></section-sub-title>
                <div class="collection-wrapper">
                    <div class="elements">
                        <snowpeak-product-tile
                            :product="p"
                            :in-bundle="productInBundle(p)"
                            @add-product="addProductToBundle"
                            class="product-tile"
                            v-for="(p, index) in step6Products"
                            :key="'extension-'+index"
                            />
                    </div>
                </div>

                <section-title :text="headlines.section4Heading"></section-title>

                <section-sub-title :text="headlines.step7Heading"></section-sub-title>
                <div class="collection-wrapper">
                    <div class="elements">
                        <snowpeak-product-tile
                            :product="p"
                            :in-bundle="productInBundle(p)"
                            @add-product="addProductToBundle"
                            class="product-tile"
                            v-for="(p, index) in step7Products"
                            :key="'case-'+index"
                            />
                    </div>
                </div>
            </div>
        </div>

        <div id="your-bundle" :class="{shown: bundleShown}">
            <div class="container">
                <div class="padded flex">
                    <h4>Your Iron Grill Table Bundle</h4>
                    <div class="bundle-items" :class="{shown: bundleShown}">
                        <a href="#" @click.prevent="shiftBundlePreview(-1)" :class="{disabled: !canShiftBundleLeft}"><img :src="images.leftArrow" alt="Expand Bundle" /></a>
                        <div class="bundle-mask">
                            <span v-if="bundleProducts.length === 0">You have no items in your bundle</span>
                            <ul v-else :style="{width: bundleWidth, marginLeft: bundleViewShift}">
                                <li v-for="(p, i) in bundleProducts" :key="'bp-'+i">
                                    <a class="remove" href="#" @click.prevent="removeProductFromBundle(i)">
                                        <svg width="8" height="9" xmlns="http://www.w3.org/2000/svg">
                                            <g stroke-width="1.125" stroke="#2E2B2C" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                                <path d="M.785 1.56l6.08 6.08M.785 7.64l6.08-6.08"></path>
                                            </g>
                                        </svg>
                                    </a>
                                    <img :src="p.product.images[0]" alt="Product Image" />
                                    <p class="desktop-description">
                                        {{ ellipsis(p.product.title) }}<br />
                                        ${{ (p.product.price / 100).toFixed(2) }}
                                    </p>
                                    <p class="mobile-description">
                                        <span>{{ p.product.title }}</span>
                                        <span>${{ (p.product.price / 100).toFixed(2) }}</span>
                                    </p>
                                    <div class="bundle-quantity">
                                        <a href="#" @click.prevent="changeQuantity(i, -1)">-</a>
                                        <span>{{ p.quantity }}</span>
                                        <a href="#" @click.prevent="changeQuantity(i, 1)">+</a>
                                    </div>
                                    <div class="bundle-quantity-mobile">
                                        <input type="number" v-model="p.quantity" />
                                    </div>
                                </li>
                                <li class="clear-bundle-li">
                                    <a href="#" @click.prevent="clearBundle">Clear IGT Bundle</a>
                                </li>
                            </ul>
                        </div>
                        <a href="#" @click.prevent="shiftBundlePreview(1)" :class="{disabled: !canShiftBundleRight}"><img :src="images.rightArrow" alt="Expand Bundle" /></a>
                    </div>
                    <div class="bundle-info">
                        <p><span>Total Items: {{ bundleItemCount }}</span><br />
                            <span>Total Price: {{ bundlePrice }}</span>
                            <a href="#" v-if="bundleShown" @click.prevent="clearBundle" class="clear-bundle-link">Clear IGT Bundle</a>
                        </p>
                    </div>
                    <a href="#" v-if="!bundleShown" @click.prevent="clearBundle" class="clear-bundle-link">Clear IGT Bundle</a>
                    <div class="cart-link-wrapper">
                        <a href="#" class="btn btn-outline" @click.prevent="addToCart">Add all to Cart</a>
                    </div>
                    <div class="bundle-preview-toggle" :class="{shown: bundleShown}" @click.prevent="bundleShown = !bundleShown"><img :src="images.upArrow" alt="Expand Bundle" /></div>
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../scss/_variables";

.app-wrapper {
    background-color: $c-section-bg;
    padding-top: 100px;
}

#your-bundle {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    background: $c-black-100;
    border: 1px solid $c-grey;
    color: $c-collection-nav-border;
    height: 75px;
    overflow: hidden;
    transition: height 0.3s ease;
    z-index: 10;

    @media screen and (max-width: $screen-laptop) {
        height: 170px;
        background: linear-gradient(to top, $c-black, $c-black 108px, $c-black-100 108px, $c-black-100);
    }

    .container {
        height: 100%;

        @media screen and (max-width: $screen-laptop) {
            padding-bottom: 20px;
        }

        .flex {
            height: 100%;
            align-items: center;

            @media screen and (max-width: $screen-laptop) {
                flex-direction: column;
            }
        }
    }

    &.shown {
        height: 250px;

        @media screen and (max-width: $screen-laptop) {
            height: 560px;
            max-height: calc(100vh - 102px);
        }

        .cart-link-wrapper {
            padding-right: 0;
            transform: translateX(26px);
            padding-left: 24px;

            @media screen and (max-width: $screen-laptop) {
                transform: translateX(0);
            }
        }
    }

    a {
        color: $c-collection-nav-border;

        &.disabled {
            opacity: 0.3;
            cursor: initial;
        }
    }

    h4 {
        margin-right: 80px;
        width: 210px;

        @media screen and (min-width: 1500px) {
            width: auto;
        }
        @media screen and (min-width: 993px) {
            margin-right: 0;
        }
        @media screen and (min-width: 1050px) {
            margin-right: 60px;
        }
        @media screen and (max-width: $screen-laptop) {
            order: 1;
            width: 400px;
            max-width: calc(100% - 50px);
            margin: 4px auto 0 0;
            text-transform: none;
            letter-spacing: 1px;
        }
    }

    .bundle-items {
        opacity: 0;
        transition: all 0.3s linear;
        flex: 1;
        display: flex;
        align-items: center;
        overflow: hidden;
        padding-right: 30px;

        &.shown {
            opacity: 1;
        }

        .bundle-mask {
            margin: 0 30px;
            width: 650px;
            overflow: hidden;

            & > span {
                display: block;
                text-align: center;
            }
        }

        ul {
            display: block;
            height: 200px;
            transition: margin 0.3s ease;
        }

        li {
            width: 130px;
            position: relative;
            text-align: center;
            padding: 15px;
            display: block;
            float: left;

            img {
                width: 80%;
            }

            a.remove {
                position: absolute;
                top: 0;
                right: 10px;
                width: 26px;
                height: 26px;
                line-height: 26px;
                text-align: center;
                color: $c-black-100;
                background-color: $c-collection-nav-border;
                border-radius: 13px;
                text-align: center;
                font-family: sans-serif;
            }

            p {
                line-height: 20px;

                &.mobile-description {
                    display: none;
                }
                @media screen and (max-width: $screen-laptop) {
                    &.desktop-description {
                        display: none;
                    }

                    &.mobile-description {
                        display: flex;
                        flex: 1;
                        justify-content: space-between;
                        align-items: center;

                        span {
                            text-align: left;
                        }
                    }
                }
            }

            &.clear-bundle-li {
                display: none;

                a {
                    text-decoration: underline;
                }

                @media screen and (max-width: $screen-laptop) {
                    display: block;
                    width: 100%;
                    border: 0;
                }
            }
        }

        @media screen and (max-width: $screen-laptop) {
            order: 2;
            width: 100%;
            padding: 15px 0px 5px;
            flex-direction: column;

            & > a {
                display: none;
            }

            .bundle-mask {
                width: 100%;
                margin: 0;
                overflow: scroll;
            }

            ul {
                height: auto;
                width: 100% !important;
                margin-left: 0 !important;
            }

            li {
                float: none;
                width: auto;
                border-bottom: 1px solid $c-collection-nav-border;
                padding: 8px 0;
                display: flex;

                img {
                    height: 50px;
                    width: auto;
                    padding-right: 13px;
                }

                a.remove {
                    right: 0;
                    top: 19px;
                }
            }
        }
    }
}
.product-tile-list {
    display: flex;
}
.product-tile {
    flex: 1;
    display: block;
}

.collection-wrapper {
    background-color: transparent;

}

.cart-link-wrapper {
    padding: 0 50px;
    transition: all 0.3s ease;

    a {
        border-color: $c-bundle-grey;
        color: $c-bundle-grey;
    }

    @media screen and (max-width: $screen-laptop) {
        order: 4;
        padding: 10px 0 0 !important;
        max-width: 100%;
        width: 400px;

        a {
            display: block;
            width: 100%;
        }
    }
}

.bundle-preview-toggle {
    cursor: pointer;
    transition: all 0.3s ease;

    &.shown {
        align-self: flex-start;
        padding-bottom: 28px;
        transform: rotate(180deg);
    }

    @media screen and (max-width: $screen-laptop) {
        align-self: flex-end !important;
        padding: 0 !important;
        transform: translateY(25px);

        &.shown {
            transform: rotate(180deg) translateY(-25px);
        }
    }
}

.clear-bundle-link {
    color: $c-bundle-grey;
    text-decoration: underline;
    margin-left: 90px;
    display: block;

    @media screen and (max-width: $screen-laptop) {
        display: none;
    }

    .bundle-info & {
        margin-left: 0;
    }
}

.bundle-info {
    text-transform: uppercase;

    @media screen and (max-width: $screen-laptop) {
        order: 3;
        text-transform: none;
        width: 100%;

        p {
            display: flex;
            width: 400px;
            max-width: 100%;
            justify-content: space-between;
            margin: 0 auto;
        }
    }

    a {
        text-transform: none;
    }
}

.bundle-quantity {
    border: 1px solid $c-white;
    color: $c-white;
    margin: 10px 20% 0;

    @media screen and (max-width: $screen-laptop) {
        display: none;
    }

    a {
        display: inline-block;
        color: $c-white;
        width: 15px;
    }
}

.bundle-quantity-mobile {
    display: none;

    @media screen and (max-width: $screen-laptop) {
        display: flex;
        align-items: center;
        margin: 0 40px 0 15px;
    }

    input {
        border: 1px solid $c-white;
        width: 39px;
        color: $c-white;
        background-color: $c-black-100;
        text-align: center;
        padding: 8px 0;
    }
}

.bundle-popup {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
    background: rgba(238,238,238,0.9);
    display: flex;
    align-items: center;
    justify-content: center;

    .message {
        background: $c-white;
        padding: $grid-gutter-width;
        width: 666px;
        max-width: 90%;
        text-align: center;

        p {
            font-size: 20px;
            margin-bottom: 40px;
        }

        .buttons {
            display: flex;
            justify-content: space-evenly;
            flex-wrap: wrap;

            button {
                margin-top: 16px;
            }
        }
    }
}
</style>

<script>
import SectionTitle from "./SectionTitle";
import SectionSubTitle from "./SectionSubTitle";
import Axios from "axios";
import SnowpeakProductTile from "./SnowpeakBundleProductTile";

export default {
    data() {
        return {
            images: window.igtImages,
            products: window.igtProducts,
            headlines: window.igtTextItems,
            bundleProducts: [],
            bundlePreviewScrollPosition: 0,
            bundlePreviewSize: 0,
            bundleShown: false,
            confirmMessage: "",
            confirmButtons: [],
            helperShown: false,
        }
    },
    components: {
        SectionTitle,
        SectionSubTitle,
        SnowpeakProductTile
    },
    computed: {
        step1Products() {
            return this.products.filter(p => {
                if (p.tags.includes(this.headlines.step1tag)) {
                    return true;
                }

                return false;
            })
        },
        step2Products() {
            return this.products.filter(p => {
                if (p.tags.includes(this.headlines.step2tag)) {
                    return true;
                }

                return false;
            })
        },
        step3Products() {
            return this.products.filter(p => {
                if (p.tags.includes(this.headlines.step3tag)) {
                    return true;
                }

                return false;
            })
        },
        step4Products() {
            return this.products.filter(p => {
                if (p.tags.includes(this.headlines.step4tag)) {
                    return true;
                }

                return false;
            })
        },
        step5Products() {
            return this.products.filter(p => {
                if (p.tags.includes(this.headlines.step5tag)) {
                    return true;
                }

                return false;
            })
        },
        step6Products() {
            return this.products.filter(p => {
                if (p.tags.includes(this.headlines.step6tag)) {
                    return true;
                }

                return false;
            })
        },
        step7Products() {
            return this.products.filter(p => {
                if (p.tags.includes(this.headlines.step7tag)) {
                    return true;
                }

                return false;
            })
        },
        canShiftBundleLeft() {
            return this.bundlePreviewScrollPosition > 0;
        },
        canShiftBundleRight() {
            return this.bundleProducts.length > (this.bundlePreviewScrollPosition + this.bundlePreviewSize);
        },
        bundleWidth() {
            return (130 * this.bundleProducts.length) + "px"
        },
        bundleItemCount() {
            let count = 0;
            this.bundleProducts.forEach( (p) => {
                count += p.quantity
            })

            return count
        },
        bundlePrice() {
            let price = 0;
            this.bundleProducts.forEach( (p) => {
                price += ((p.product.price * p.quantity) / 100)
            })

            return "$" + price.toFixed(2)
        },
        bundleViewShift() {
            return (this.bundlePreviewScrollPosition * -130) + "px";
        }
    },
    methods: {
        productInBundle(product) {
            let inBundle = false

            this.bundleProducts.forEach(p => {
                if (p.product.id === product.id) {
                    inBundle = true
                }
            })

            return inBundle
        },
        addProductToBundleFromQuickView(id, qty) {
            if (!this.helperShown) {
                this.helperShown = true;

                toastr.options.positionClass = "toast-bottom-right";
                toastr.options.timeOut = 0;
                toastr.options.hideDuration = 500;
                toastr.options.onclick = () => {
                    setTimeout(() => {
                        this.bundleShown = true;
                    }, 500)
                }
                toastr.success("<p style='margin-bottom: 15px'>This product has been added to your bundle. Control the items in your bundle by clicking the arrow at the bottom of the page.</p><span class='btn btn-outline'>Show me</span>");
                window.localStorage.setItem("snowpeak-helper-last-shown", +new Date())
            }

            for (let index = 0; index < this.products.length; index++) {
                const element = this.products[index];

                if (element.id === id) {
                    this.bundleProducts.push({
                        product: element,
                        quantity: qty
                    })
                    return
                }
            }

            console.log("couldn't find that product")
        },
        addProductToBundle(p) {
            if (!this.helperShown) {
                this.helperShown = true;

                toastr.options.positionClass = "toast-bottom-right";
                toastr.options.timeOut = 0;
                toastr.options.hideDuration = 500;
                toastr.options.onclick = () => {
                    setTimeout(() => {
                        this.bundleShown = true;
                    }, 500)
                }
                toastr.success("<p style='margin-bottom: 15px'>This product has been added to your bundle. Control the items in your bundle by clicking the arrow at the bottom of the page.</p><span class='btn btn-outline'>Show me</span>");
                window.localStorage.setItem("snowpeak-helper-last-shown", +new Date())
            }

            this.bundleProducts.push({
                product: p,
                quantity: 1
            })
        },
        removeProductFromBundle(index) {
            this.bundleProducts.splice(index, 1)
        },
        clearBundle() {
            this.bundleProducts = [];
            this.confirmMessage = "";
        },
        shiftBundlePreview(offset) {
            // if we are trying to shift the preview to the right, but we can't, return early
            if (offset === 1 && !this.canShiftBundleRight) {
                return
            }

            let newOffset = this.bundlePreviewScrollPosition + offset;
            if (newOffset < 0) {
                newOffset = 0;
            }

            this.bundlePreviewScrollPosition = newOffset;
        },
        getCurrentBundle() {
            // this will build up a DTO in the structure that shopify wants so that we can POST
            // all these items to add them to the cart.
            // not the most efficient code, but good enough for this prototype
            let output = [];
            this.bundleProducts.forEach(p => {
                output.push({
                    quantity: p.quantity,
                    id: p.product.variants[0].id,
                    properties: {
                        igtBundle: true
                    }
                })
            });
            return output
        },
        showAddedToCartMessage() {
            this.confirmMessage = "This bundle has been added to your cart. Would you like to go to your cart or continue editing your bundle?";
            this.confirmButtons = [
                {
                    text: "Go to cart",
                    action: () => {
                        window.location = "/cart";
                    }
                },
                {
                    text: "Continue Editing",
                    action: () => {
                        this.confirmMessage = "";
                    }
                }
            ]
        },
        addToCart() {
            if (this.bundleProducts.length === 0) {
                this.confirmMessage = "Please add items to your bundle before adding your bundle to your cart.";
                this.confirmButtons = [
                    {
                        text: "Continue",
                        action: () => {
                            this.confirmMessage = ""
                        }
                    }
                ]
                return;
            }
            // check existing cart for a bundle
            Axios.get("/cart.js").then( (checkCartResponse) => {
                const cartHasBundleItems = this.checkCurrentCartContentsForBundle(checkCartResponse);
                if (cartHasBundleItems) {
                    // const clearBundleFromCart = confirm("Your cart currently contains a bundle. Would you like to remove the existing bundle from your cart?");
                    // this.removeBundleItemsFromCart();

                    this.confirmMessage = "Your cart currently contains a bundle. Would you like to replace the existing bundle in your cart with your current bundle?";
                    this.confirmButtons = [
                        {
                            text: "Yes",
                            action: () => {
                                this.removeBundleItemsFromCart();
                                setTimeout(() => {
                                    // now we add in all the products for the current bundle
                                    let itemsToPurchase = this.getCurrentBundle();
                                    Axios.post("/cart/add.js", {
                                        items: itemsToPurchase
                                    }).then( () => {
                                        this.showAddedToCartMessage();
                                    }).catch( (error) => {
                                        console.log(error);
                                    })
                                }, 500)
                            }
                        },
                        {
                            text: "No",
                            action: () => {
                                this.confirmMessage = "";
                            }
                        }
                    ]
                } else {
                    // now we add in all the products for the current bundle
                    let itemsToPurchase = this.getCurrentBundle();
                    Axios.post("/cart/add.js", {
                        items: itemsToPurchase
                    }).then( () => {
                        this.showAddedToCartMessage();
                    }).catch( (error) => {
                        console.log(error);
                    })
                }
            }).catch( (error) => {
                // TODO: we need to figure out error handling
                console.log(error);
            });
        },
        checkCurrentCartContentsForBundle(axiosResponse) {
            // here is where we can check to see if we need to clear any existing bundles from the cart before adding in these various items
            // this method returns a boolean, true if there are "bundle" items in the cart
            // false if there are no bundle items in the cart
            let cartItems = axiosResponse.data.items;
            if (cartItems.length === 0) {
                return false;
            }
            // loop over the cart products and check for any tagged with the igtBundle property
            for (let index = 0; index < cartItems.length; index++) {
                const lineItem = cartItems[index];
                if (!lineItem.properties) {
                    continue;
                }
                if (lineItem.properties.igtBundle) {
                    return true;
                }
            }
            return false;
        },
        removeBundleItemsFromCart() {
            return new Promise( () => {
                Axios.get("/cart.js").then( (response) => {
                    let cartItems = response.data.items;
                    if (cartItems.length === 0) {
                        return false;
                    }
                    let variantsToClear = {};
                    for (let index = 0; index < cartItems.length; index++) {
                        const lineItem = cartItems[index];
                        if (!lineItem.properties) {
                            continue;
                        }
                        if (lineItem.properties.igtBundle) {
                            variantsToClear[lineItem['variant_id']] = 0
                        }
                    }
                    console.log(variantsToClear)
                    Axios.post("/cart/update.js", {
                        updates: variantsToClear
                    });
                });
            });
        },
        ellipsis(s) {
            const chars = 10;
            if (s.length < chars) {
                return s;
            }

            return s.substr(0, chars) + "...";
        },
        changeQuantity(i, v) {
            this.bundleProducts[i].quantity += v // update the quantity

            // if quantity is now 0, remove it from the bundle
            if (this.bundleProducts[i].quantity === 0) {
                this.bundleProducts.splice(i, 1)
            }
        },
        updateBundlePreviewSize() {
            this.bundlePreviewSize = Math.floor($(".bundle-mask").width() / 130);
        },
        loadCartBundleItems() {
            Axios.get("/cart.js").then( (checkCartResponse) => {
                let cartItems = checkCartResponse.data.items;
                if (cartItems.length === 0) {
                    return;
                }
                // loop over the cart products and check for any tagged with the igtBundle property
                for (let index = 0; index < cartItems.length; index++) {
                    const lineItem = cartItems[index];
                    if (!lineItem.properties) {
                        continue;
                    }

                    if (lineItem.properties.igtBundle) {
                        let p = null;
                        for (let index = 0; index < this.products.length; index++) {
                            const element = this.products[index];
                            // console.log(element)
                            // console.log(lineItem.id)

                            if (element.variants[0].id === lineItem.id) {
                                // push the matching item into the current bundle
                                this.bundleProducts.push({
                                    product: element,
                                    quantity: lineItem.quantity
                                })
                            }
                        }
                    }
                }
                return;
            });
        }
    },
    watch: {
        bundleShown() {
            if (this.bundleShown) {
                window.jQuery(".back-to-top").css("bottom", 280);
            } else {
                window.jQuery(".back-to-top").css("bottom", 105);
            }
        },
        bundleProducts() {
            this.updateBundlePreviewSize();
        }
    },
    mounted() {
        // check local storage for bundle message so that we don't show it on each page load
        // this will timeout each 12 hours
        const ts = window.localStorage.getItem("snowpeak-helper-last-shown");
        if (ts) {
            const hours = 12;
            let now = +new Date();
            if ((now - ts) < (hours * 60 * 60 * 1000)) {
                this.helperShown = true
            }
        }

        // check cart for current bundle
        Axios.get("/cart.js").then( (checkCartResponse) => {
            const cartHasBundleItems = this.checkCurrentCartContentsForBundle(checkCartResponse);

            if (cartHasBundleItems) {
                this.confirmMessage = "There is currently an IGT bundle in your cart. Starting a new bundle will remove the current bundle from your cart. Would you like to edit that bundle or start over?";
                this.confirmButtons = [
                    {
                        text: "Start Over",
                        action: () => {
                            this.clearBundle();
                            this.removeBundleItemsFromCart();
                        }
                    },
                    {
                        text: "Edit Existing Bundle",
                        action: () => {
                            this.loadCartBundleItems();
                            this.confirmMessage = "";
                        }
                    }
                ]
            }
        });
    }
}
</script>
